

<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Featured Events</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  
  <div style="font-size: 10px" class="container tablecontainer">
      <div class="row">
  
        <div class="search">
          <label for="search">Search</label>
    
          <div class="md-form">
            <input style="border: 1px solid #5d2041;"
              type="text"
              [(ngModel)]="searchText"
              class="form-control"
              id="search"
              mdbInput
            />
          </div>
        </div>
    <form class="sortingdiv" [formGroup]="sortForm" >
      <label style="font-size: 14px;" for="search">Sort</label>
      <div class="md-form">
      <mat-form-field appearance="outline" >
        <mat-select enableeOptionCentering formControlName="sort" >
          <mat-option >
            
          </mat-option>
        </mat-select>
      </mat-form-field>
      </div>
    </form>
      </div>
  
      <table mdbTable #eventsTable="mdbTable" class="z-depth-1">
        <thead style="background-color: #5d2041; color: white;">
          <tr>
            <th
              *ngFor="let head of headElements; let i = index"
              aria-controls="tableSortExample" 
              scope="col" 
              [mdbTableSort]="allSponsoredEvents" 
              [sortBy]="headElements[i]"
            >
              {{head | titlecase}}
            </th>
            
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let el of allSponsoredEvents; let i = index">
            <th *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex"
              scope="row">{{allSponsoredEvents[i].id}}</th>
              
            <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{allSponsoredEvents[i].eventName}}</td>
            <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{allSponsoredEvents[i].organizerName}}</td>
            <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{allSponsoredEvents[i].sponsorshipDate | date: 'MMM dd,yyyy HH:mm'}}</td>
            <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{allSponsoredEvents[i].sponsorshipEndDate | date: 'MMM dd,yyyy HH:mm'}}</td>
            <!-- <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{allSponsoredEvents[i].country}}</td> -->
            <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{allSponsoredEvents[i].payment}}$</td>
  
          </tr>
            <td colspan="4">
              <mdb-table-pagination [tableEl]="eventsTable" [searchDataSource]="allSponsoredEvents"></mdb-table-pagination>
            </td>
        </tbody>
      </table>
    </div>